<template>
  <div class="directiveTypesWrap">
    <div class="searchWrap">
      <span class="label"> {{ $tt("指令类型名称：") }} </span>
      <el-input
        v-model="searchValue"
        :placeholder="$tt('请输入内容')"
        clearable
      ></el-input>
      <el-button type="primary" icon="el-icon-search" @click="search"
        >{{ $tt("搜索") }}</el-button
      >
    </div>
    <div class="operations">
      <el-button
        type="primary"
        @click="$router.push('/privateResource/directiveTypes/add')"
        >{{ $tt("添加") }}</el-button
      >
      <el-button
        type="danger"
        @click="deleteDirectiveTypes(selectedDirectives.map((item) => item.id))"
        >{{ $tt("批量删除") }}</el-button
      >
    </div>
    <div class="directiveTypesList">
      <el-table
        ref="multipleTable"
        :data="directivesListData.result"
        tooltip-effect="dark"
        style="width: 100%"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          :prop="c.key"
          :label="$tt(c.label)"
          :width="$listColWidth(c)"
          :min-width="$listColMinWidth(c)"
          :prop="$listColProp(c)"
          :sortable="$listSortable(c)"
          :class-name="$listColClass(c)"
          :label-class-name="$listColClass(c)"
        :fixed="$listColFixed(c)"
          show-overflow-tooltip
          v-for="c in columns"
          :key="c.key"
        >
          <template slot-scope="scope">
            <span v-if="c.key == 'create_time'">{{
              getTime(scope.row.create_time)
            }}</span>
            <span v-else>{{ scope.row[c.key] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="operation"
          :label="$tt('操作')"
          min-width="160"
          width="160"
          class-name="table-ops-cell"
          label-class-name="table-ops-cell"
          key="operation"
          fixed="right"
        >
          <template slot-scope="scope">
            <div class="table-ops">
            <el-button type="text" size="mini" icon="el-icon-edit" @click="toEdit(scope.row.id)"
              >{{ $tt("编辑") }}</el-button
            >
            <el-button
              type="text"
              class="table-op-danger"
              size="mini"
              icon="el-icon-delete"
              @click="deleteDirectiveTypes([scope.row.id])"
              >{{ $tt("删除") }}</el-button
            >
            </div>
          </template>
        </el-table-column>
      </el-table>

      <Pagination
        v-if="directivesListData.total > 8"
        :handleSizeChange="handleSizeChange"
        :handleCurrentPageChange="handleCurrentPageChange"
        :pageNum="pageNum"
        :total="directivesListData.total"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import moment from "moment";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      columns: [
        {
          key: "type_name",
          label: "指令类型名称",
        },
        {
          key: "create_time",
          label: "创建时间",
        },
      ],
      directivesListData: {},
      selectedDirectives: [],
      searchValue: "",
      pageNum: 1,
      pageSize: 8
    };
  },
  mounted() {
    this.queryDirectiveTypesList({});
  },
  methods: {
    search() {
      this.queryDirectiveTypesList({
        type_name: this.searchValue,
      });
    },
    deleteDirectiveTypes(ids) {
      this.$request.deleteDirectiveTypes({ ids }).then((res) => {
        if (res.status != "success") {
          this.$message.error(res.msg);
          return;
        }
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.queryDirectiveTypesList({});
      });
    },
    queryDirectiveTypesList({ page_num, page_size, type_name }) {
      this.$request
        .queryDirectiveTypesList({
          page_num: page_num || this.pageNum,
          page_size: page_size || this.pageSize,
          type_name,
        })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.directivesListData = res?.data || {};
        });
    },
    getTime(t) {
      return moment(t).format("YYYY-MM-DD HH:mm");
    },
    handleSizeChange(v) {
      this.pageNum = 1;
      this.pageSize = v;
      this.queryDirectiveTypesList({ page_size: v });
    },
    toEdit(id) {
      this.$router.push({
        path: "/privateResource/directiveTypes/edit",
        query: {
          id,
        },
      });
    },
    handleCurrentPageChange(v) {
      this.pageNum = v;
      this.queryDirectiveTypesList({ page_num: v });
    },
    handleSelectionChange(val) {
      this.selectedDirectives = val;
    },
  },
};
</script>

<style lang='scss' scoped>
.directiveTypesWrap {
  background-color: #fff;
  .searchWrap {
    display: flex;
    border-bottom: 1px solid #e6e6e6;
    padding: 16px 0;
    align-items: center;
    .label {
      margin-left: 16px;
    }
    .el-input {
      width: 200px !important;
    }
    .el-button {
      margin-left: 16px;
    }
  }
  .operations {
    margin: 24px 24px 0;
  }
  .directiveTypesList {
    padding: 10px 24px 24px;
  }
}
</style>